"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.merge = void 0;
// Use syntax "import module = require('module') because type def is "export = deepmerge"
// See https://www.typescriptlang.org/docs/handbook/modules.html#export--and-import--require
const deepmerge = require("deepmerge");
const is_plain_object_1 = require("is-plain-object");
const merge = (...objects) => deepmerge.all(objects, {
    // Copy ObjectId objects
    isMergeableObject: is_plain_object_1.isPlainObject,
});
exports.merge = merge;
//# sourceMappingURL=merge.js.map